import React from 'react'
import { Row, Col, Button } from 'antd'
import ParticlesBg from "particles-bg";
import { connect } from 'react-redux';
import { changeEntity } from '../../redux/entity/actions/actions';



 function ChooseEntity(props){

    const handleClick = (entity) => {

    switch(entity){
        case "ROYALMARKETING":{
            props.selectEntity("ROYALMARKETING")
            break;
        }
        case "SEGA":{
            props.selectEntity("SEGA")
            break;
        }
    }
       
    }

    return (
        <>
        <Row style={{}}>
            <Col style={{textAlign:"center" }} >
                <div style={{padding:"1% 1%"}} >
                    <h1 style={{color:"white"}}> WELCOME TO RIB SYSTEM MANAGER</h1>
                </div>
            </Col>
        </Row>
         <Row >       
             <Col style={{textAlign:"center" ,  padding:"15% 0" , color:"#fff"  }} span={12}>
                 <div style={{position:"relative",top:"100%" }}>
                    <h1 style={{color:"white"}}>SEGA</h1>
                    <Button onClick={() => handleClick("SEGA")} type="primary" size="large"> Manage SEGA</Button>
                 </div>
             </Col>
             <Col style={{textAlign:"center" ,  padding:"15% 0"  , color:"#fff"  }} span={12}>
                <div style={{position:"relative",top:"100%" }}>
                    <h1 style={{color:"white"}} >ROYAL MARKETING</h1>
                    <Button onClick={() => handleClick("ROYALMARKETING")} type="primary" size="large"> Manage ROYAL MARKETING</Button>
                 </div>
             </Col>
         </Row>
         <ParticlesBg  type="thick" bg></ParticlesBg>
        </>
    )
}

const mapDispatchToProps = dispatch => ({
    selectEntity : (entity) => dispatch(changeEntity(entity))
})

export default connect(null,mapDispatchToProps)(ChooseEntity)